export function getDecimalPlacesCount(multipleOf: number): number {
  return String(multipleOf).split('.')?.[1]?.length || 0;
}

export function deserializeDate(value?: string): {
  YEAR?: string;
  MONTH?: string;
  DAY?: string;
} {
  if (!value) {
    return {};
  }

  const parts = value.split('-');

  if (parts.length === 3) {
    const [year, month, day] = parts;

    return {
      YEAR: year || undefined,
      MONTH: month || undefined,
      DAY: day || undefined,
    };
  }

  return {};
}

export function parseDateTimeValue(value?: string): [string, string] {
  if (!value) {
    return ['', ''];
  }

  const separator = value.indexOf('T') > -1 ? 'T' : ' ';
  const [date, time] = value.split(separator);

  return [date || '', time || ''];
}

export function isTimeComplete(time?: string): boolean {
  if (!time) {
    return false;
  }

  const [hours, minutes] = time.split(':');

  return !!hours && !!minutes;
}
